/**
 * マニフェスト管理 最終処分終了報告
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

const manifest_management_final_disposal = {

  namespaced: true,
  actions: {
    /**
     * 取消処理
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    delete ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/final_disposals`
        Vue.$http.delete(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '取消しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}

export default manifest_management_final_disposal
